<template>
	<div>
		<Header :mode="'album'"></Header>
		<PageHeading mode="alert"></PageHeading>
		<PrimaryMenu></PrimaryMenu>
		<LibraryAlbum></LibraryAlbum>
		<ScrollTop></ScrollTop>
		<Footer mode="album-black"></Footer>
	</div>
</template>

<script>
import Header from "../components/Header";
import PrimaryMenu from "../components/PrimaryMenu";
import LibraryAlbum from "../components/LibraryAlbum";
import PageHeading from "../components/PageHeading";
import ScrollTop from "../components/ScrollTop";
import Footer from "../components/Footer";
import store from "../store/";

export default {
	name: "LibraryAlbumPage",
	store,
	components: {
		Header,
		PrimaryMenu,
		PageHeading,
		LibraryAlbum,
		ScrollTop,
		Footer,
	},
	created() {
		document.title = this.$route.meta.title;
	},
	computed: {
        album() {
			return this.$store.state["LibraryAlbum"].album;
		}
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/LibraryAlbumPage.vue